import { TicketReportStatus } from "./enums/ticket-report-status";
import { TicketPriority } from "./enums/ticketPriority.enum";

export class TicketToolReport {
    public id: number;
    public name: string;
    public url: string;
    public ticketId: string;
    public ticketReportPriority?: TicketPriority;
    public status?: TicketReportStatus;

    constructor(ticketReport: any = {}) {
        this.id = ticketReport.id;
        this.name = ticketReport.name;
        this.url = ticketReport.url;
        this.ticketId = ticketReport.ticketId;
        this.ticketReportPriority = ticketReport.ticketReportPriority;
        this.status = ticketReport.status;
    }
}
